<div class="auction-detail-cntr" #auctionCard>

    <p-card [header]="localBatch.ProductName" [subheader]="getSubHeader()" [style]="{ width: '100%' }">

        <ng-template pTemplate="header">
            <p-carousel *ngIf="localBatch.ProductFiles.length > 0" [value]="localBatch.ProductFiles"
                [numVisible]="1" [numScroll]="1" [circular]="true" [autoplayInterval]="3000"
                styleClass="image-carousel-with-arrows-inside">
                <ng-template pTemplate="item" let-file>
                    <img style="height: 400px; display: block; margin: 0 auto;" [src]="file.Endpoint"
                        [alt]="localBatch.ProductName" />
                </ng-template>
            </p-carousel>
            <div class="seller-absolute" *ngIf="sellerConfiguration">
                <fb-seller-info [configuration]="sellerConfiguration"></fb-seller-info>
            </div>
        </ng-template>

        <p>
            {{localBatch.ProductDescription}}
        </p>

        <h4 style="font-weight: bold">Tipologia Asta: {{multipleBatch ? 'Multiplo' : 'Singolo' }}</h4>
        <h4 style="font-weight: bold">Stato Asta:
            {{this.getBatchAvailabilityStatusTranslation(localBatch.Status)}}</h4>
        <h4 style="font-weight: bold">Offerte attive: {{localBatch.TotalOffers ?? 0}}</h4>

        <ng-container *ngIf="multipleBatch;else singleTmpl">

            <h4 style="font-weight: bold"
                *ngIf="this.localBatch.RankingInfos && this.localBatch.RankingInfos.TotalBids > 0; else noRankTmpl">
                Ti stai aggiundicando: {{this.localBatch.RankingInfos.WinningBids}} {{multipleBatch ? 'lotti' :
                'lotto'}} su {{this.localBatch.RankingInfos.TotalBids}} {{multipleBatch ? 'puntati' :
                'puntato'}}. </h4>

            <ng-template #noRankTmpl>
                <h4 style="font-weight: bold" *ngIf="this.userService.roleChecker.is.customer()" (click)="bid()">Partecipa all'asta</h4>
            </ng-template>

        </ng-container>

        <ng-template #singleTmpl>

            <h4 style="font-weight: bold" *ngIf="this.localBatch.RankingInfos && this.userService.roleChecker.is.customer(); else noRankTmpl"> Offerta vincente:
                {{this.localBatch.RankingInfos.WinningBids? "Si ✅" : "No ❌"}} </h4>

        </ng-template>

    </p-card>

    <div class="button-cntr" *ngIf="priceButtonConfiguration || timeButtonConfiguration">

        <auction-detail-button *ngIf="priceButtonConfiguration"
            [configuration]="priceButtonConfiguration"></auction-detail-button>
        <auction-detail-button *ngIf="timeButtonConfiguration"
            [configuration]="timeButtonConfiguration"></auction-detail-button>

    </div>

    <div class="button-cntr" *ngIf="bidButtonConfiguration || positionButtonConfiguration">

        <auction-detail-button *ngIf="bidButtonConfiguration"
            [configuration]="bidButtonConfiguration"></auction-detail-button>
        <auction-detail-button *ngIf="positionButtonConfiguration"
            [configuration]="positionButtonConfiguration"></auction-detail-button>

    </div>

    <div class="submit-cntr" *ngIf="submitButtonConfiguration">

        <div class="mb-3" *ngIf="localBatch.Quantity > 1">

            <pn-input-control [configuration]="bidInputConfiguration"></pn-input-control>

        </div>

        <fb-general-button [configuration]="submitButtonConfiguration"></fb-general-button>

    </div>
    <div class="bid-form-container" *ngIf="showBidForm">
        <ng-container *ngIf="this.localBatch.RankingInfos?.MyAmount else noAmount">

            <p>La tua ultima offerta per singolo lotto è di:
                <strong>{{this.localBatch.RankingInfos?.MyAmount}}€</strong>
            </p>

        </ng-container>
        <div *ngIf="!this.localBatch.RankingInfos?.MyAmount">
            <h4>
                Partecipa all'asta, seleziona importo da aggiungere:
            </h4>
        </div>
<div class="add-container">
        <p-inputNumber [(ngModel)]="addPrice" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="2"
            [maxFractionDigits]="5" prefix="+" (ngModelChange)="updateCurrentOffer()" [min]="0"/>
        <div class="button-bid" (click)="add(2)">+2</div>
        <div class="button-bid" (click)="add(5)">+5</div>
        <div class="button-bid" (click)="add(10)">+10</div>
</div>


        <ng-container *ngIf="this.localBatch.Quantity > 1; else singleBatch">
            <div>
                {{ generateSubtitle().text }} <strong class="bold-value">{{ generateSubtitle().totalPrice }}</strong>€ totali,
                <strong class="bold-value">{{ generateSubtitle().pricePerLot }}</strong>€ per ogni lotto puntato (<strong class="bold-value">{{ generateSubtitle().quantity }}</strong>).
              </div>
        </ng-container>

        <ng-template #singleBatch>
            <p>Stai per offrire: <strong>{{currentOffer}}€</strong></p>
        </ng-template>

        <ng-container *ngIf="localBatch?.RankingInfos?.Place; else noAddressTmpl">
            <p>
              In caso di vittoria l'asta sarà recapitata all'indirizzo:
              <strong>{{ localBatch.RankingInfos.Place.Name }}</strong>
            </p>
          </ng-container>

          <ng-template #noAddressTmpl>

            <form [formGroup]="form">
              <p>Indirizzo a cui sarà recapitato il prodotto in caso di vittoria:</p>
              <div class="flex justify-content-start mb-4">
                <p-floatLabel>
                  <p-multiSelect
                    [style]="'width:100%'"
                    [options]="address"
                    optionLabel="label"
                    [formControlName]="'Address'"
                    [selectionLimit]="1"
                  />
                </p-floatLabel>
              </div>
            </form>
          </ng-template>

          <div class="modal-footer">
            <p-button label="Annulla" severity="danger" [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-times'" (click)="toggleBidForm()" [disabled]="isLoading" />
            <p-button label="Conferma" severity="success" [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'" (click)="onSubmit()" [disabled]="isLoading" />
        </div>
    </div>



    <div *ngIf="localBatch.TotalOffers !== 0 && userService.roleChecker.is.seller()"
        class="warning-message mb-4 center">
        <p class="warning-text">Le modifiche sono disabilitate perché ci sono partecipanti all'asta.</p>
    </div>

    <div class="submit-cntr" *ngIf="localBatch.TotalOffers == 0 && userService.roleChecker.is.seller()">

        <div class="delete-cntr flex">
            <fb-general-button *ngIf="delateButtonConfiguration"
                [configuration]="delateButtonConfiguration"></fb-general-button>
            <fb-general-button *ngIf="suspendButtonConfiguration"
                [configuration]="suspendButtonConfiguration"></fb-general-button>
        </div>

    </div>
    <div class="bid-form-container" *ngIf="suspendeBatchForm">

        <div *ngIf="!this.localBatch.RankingInfos?.MyAmount">
            <h4>
                Sospendi l'asta e imposta una nuova data e durata.            </h4>
        </div>
<div class="suspendform">
    <form [formGroup]="formSusp">
    <p>Seleziona nuova data di pubblicazione:</p>
    <p-calendar
  [(ngModel)]="date"
  [iconDisplay]="'input'"
  [showIcon]="true"
  inputId="icondisplay"
  [showTime]="true"
  [showSeconds]="false"
  [hourFormat]="24"
  [formControlName]="'date'"
  dateFormat="dd/mm/yy"
  [minDate]="today"/>
    <p>Seleziona la nuova durata della tua asta:</p>
    <p-dropdown
    [options]="timer"
    [(ngModel)]="selectedTimer"
    optionLabel="label"
    placeholder="Timer"
    [formControlName]="'timer'" />
</form>
</div>






          <div class="modal-footer">
            <p-button label="Annulla" severity="danger" [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-times'" (click)="suspendForm()" [disabled]="isLoading" />
            <p-button label="Conferma" severity="success" [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'" (click)="onSuspend()" [disabled]="isLoading" />
        </div>
    </div>

</div>

<p-toast></p-toast>
